
const tabs = document.querySelector('.js-tab-nav');
if ( tabs ) {
	import('../scripts/partners').then(module => {
		module;
	});
}
